import BaseWrapper from "../../components/ui/BaseWrapper";
import dayjs from "dayjs";
import BaseDataTableV2 from "../../components/ui/BaseDataTableV2";
import { useQuery } from "@tanstack/react-query";
import { useDispatch, useSelector } from "react-redux";
import { setWorkforceFilters } from "../../store/filters/workforceFiltersSlice";
import { deleteTalentPool } from "../../services/api/talentPool";
import { useNavigate } from "react-router-dom";
import BaseDropdownV2 from "../../components/ui/BaseDropdownV2";
import { useState } from "react";
import AddEditTalentPoolModal from "./components/AddEditTalentPoolModal";
import { showToast } from "../../store/toast/toastSlice";
import BaseConfirmModal from "../../components/ui/BaseConfirmModal";
import UserProfileLink from "../../components/ui/UserProfileLink";

const relativeTime = require("dayjs/plugin/relativeTime");

dayjs.extend(relativeTime);
const menuOptions = [
  {
    label: "Edit",
    value: "EDIT",
  },
  {
    label: "Delete",
    value: "DELETE",
  },
];

const TalentPoolsTable = ({
  talentPoolData,
  isFetchTalentPoolApiLoading,
  refetchTalentPool,
  paginationModel,
  setPaginationModel,
  rowCount,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isAddEditTalentPoolModalOpen, setIsAddEditTalentPoolModalOpen] = useState(false);
  const [isDeleteConfirmationModalOpen, setIsDeleteConfirmationModalOpen] = useState(false);

  const [isEditTalentPool, setIsEditTalentPool] = useState(false);
  const [selectedTalentPool, setSelectedTalentPool] = useState();
  const [queryParams, setQueryParams] = useState({
    page: 1,
    limit: 20,
    search: "",
  });

  const columns = [
    {
      pinLeft: true,
      field: "id",
      headerName: "ID",
      width: 130,
      renderCell: (params) => (
        <div className="flex items-center">
          <p
            className="table-font-size font-normal text-primary cursor-pointer"
            onClick={() => navigate(`/workForce/talentPool/engineers/${params.value}`)}
          >
            {params.value}
          </p>
        </div>
      ),
    },
    {
      field: "name",
      headerName: "Name",
      flex: 1,
      renderCell: (params) => (
        <p
          className="table-font-size truncate overflow-hidden whitespace-nowrap text-primary capitalize cursor-pointer"
          onClick={() => navigate(`/workForce/talentPool/engineers/${params.row.id}`)}
        >
          {params.value}
        </p>
      ),
    },
    {
      field: "_count",
      headerName: "Workforce",
      flex: 1,
      renderCell: (params) => (
        <p className="table-font-size cursor-default font-medium">{params.value.talentPoolUsers}</p>
      ),
    },
    {
      field: "createdBy",
      headerName: "Created By",
      flex: 1,
      renderCell: (params) => (
        <UserProfileLink userId={params.value?.id} className="table-font-size">
          {params.value.firstName + " " + params.value.lastName}
        </UserProfileLink>
      ),
    },
    {
      field: "actions",
      headerName: "Actions",
      flex: 0.2,
      renderCell: (params) => (
        <div style={{}}>
          <BaseDropdownV2
            menuOptions={menuOptions}
            triggerElement={<i className="fa-solid fa-ellipsis cursor-pointer ml-4 text-base"></i>}
            onItemClick={(item) => handleItemClick(item, params.row)}
          />
        </div>
      ),
    },
  ];
  const handleItemClick = (action, team) => {
    setSelectedTalentPool(team);
    if (action === "EDIT") {
      setIsAddEditTalentPoolModalOpen(true);
      setIsEditTalentPool(true);
    } else if (action === "DELETE") {
      setIsDeleteConfirmationModalOpen(true);
    }
  };
  const handleDeleteTalentPool = async (talentPoolId) => {
    try {
      await deleteTalentPool(talentPoolId);
      setIsDeleteConfirmationModalOpen(false);
      dispatch(
        showToast({
          message: "Talent Pool deleted successfully",
          type: "success",
        }),
      );
      refetchTalentPool();
    } catch (error) {
      dispatch(showToast({ message: error?.response?.data?.message, type: "error" }));
    }
  };

  const handlePaginationChange = (newPaginationModel) => {
    setPaginationModel(newPaginationModel);
  };

  return (
    <BaseWrapper>
      <div className="mt-2">
          <BaseDataTableV2
            className="max-h-[calc(100vh-300px)]  overflow-auto"
            rowHeight={46}
            columns={columns}
            data={talentPoolData?.data || []}
            isLoading={isFetchTalentPoolApiLoading}
            disableColumnResize={false}
            hideFooter={false}
            disableRowSelectionOnClick
            checkboxSelection
            rowCount={rowCount}
            pagination
            pageSizeOptions={[10, 20, 50]}
            paginationMode="server"
            paginationModel={paginationModel}
            onPaginationModelChange={handlePaginationChange}
          />
      </div>
      {isAddEditTalentPoolModalOpen && (
        <AddEditTalentPoolModal
          setIsAddEditTalentPoolModalOpen={setIsAddEditTalentPoolModalOpen}
          isAddEditTalentPoolModalOpen={isAddEditTalentPoolModalOpen}
          refetchTalentPool={refetchTalentPool}
          isEdit={isEditTalentPool}
          talentPoolData={selectedTalentPool}
        />
      )}
      {isDeleteConfirmationModalOpen && (
        <BaseConfirmModal
          open={isDeleteConfirmationModalOpen}
          onClose={() => setIsDeleteConfirmationModalOpen(false)}
          cancelText="Cancel"
          confirmText="Delete"
          confirmButtonColor="error"
          title="Delete Talent Pool"
          description={
            <p>
              Are you sure you want to delete the Talent Pool
              {
                <span className="text-red-600 font-medium mx-1 capitalize">
                  "{selectedTalentPool?.name}"
                </span>
              }
              ? All including members will be removed. This action cannot be undone.
            </p>
          }
          onConfirm={() => handleDeleteTalentPool(selectedTalentPool?.id)}
        />
      )}
    </BaseWrapper>
  );
};

export default TalentPoolsTable;
